module.exports = __webpack_public_path__ + "static/media/R9.57647338.jpg";